export default __webpack_public_path__ + "static/media/july2024-5.56ec6059.jpg";